import DeleteAction from 'components/DeleteAction';
import EditAction from 'components/EditAction';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';

const SingleAddressTile = props => {
  const [isInvalidAddress, setIsInvalidAddress] = useState<boolean>(false);
  const {
    loading,
    contactName,
    contactPhone,
    addressDetails,
    setAddress,
    deleteAddressFn,
    toggleAddressModal,
    setAddressToEdit,
    showInvalidAddresses,
    showAddressActions,
    showSelector=true,
  } = props;

  useEffect(() => {
    const isInvalidAddress = () => {
      if (!addressDetails.contactName || !addressDetails.contactPhone) return true;
      return false;
    };
    setIsInvalidAddress(isInvalidAddress);
  }, [addressDetails]);
  
  const handleAddressEdit = async (addressDetails: Record<string, any>) => {
    setAddressToEdit(addressDetails);
    toggleAddressModal();
  };

  if (!showInvalidAddresses && isInvalidAddress) return null;
  
  return (
    <div
      className={`${styles['single-address']} ${isInvalidAddress ? styles['invalid-address'] : ''}`}
    >
      {showSelector && <div className={styles['address-radio']}>
        <input
          disabled={loading || isInvalidAddress}
          type={'radio'}
          name={'default-address'}
          onChange={() => setAddress(
            {
              address: addressDetails.address,
              town: addressDetails.town,
              zip: addressDetails.zip,
              latitude: addressDetails.coords.latitude,
              longitude: addressDetails.coords.longitude,
              contactName,
              contactPhone,
              objectId: addressDetails.objectId,
            })
          }
        />
      </div>}
      <div className={styles['address-details']}>
        <div className={styles['line1']}>{`${contactName}, ${contactPhone}`}</div>
        <div className={styles['line1']}>{addressDetails.address}</div>
        <div className={styles['line2']}>{`${addressDetails.town}, ${addressDetails.zip}`}</div>
      </div>
      <div className={styles['invalid-address-error']}>
        {isInvalidAddress ? `Please add complete address details` : null}
      </div>
      <div className={styles['address-actions']}>
        {showAddressActions ? (
          <>
            <EditAction
              loading={false}
              onClick={() => handleAddressEdit(addressDetails)}
            />
            <DeleteAction
              loading={loading}
              onClick={() => deleteAddressFn(addressDetails.objectId)}
            />
          </>
        ): null}
      </div>
    </div>
  );
};

export default SingleAddressTile;